import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import type { ReleaseOption } from '../hooks/useReleaseOptions';
import { S4aHelperModal, isReleased } from './S4aHelperModal';
import { S4aPitchedMark } from './S4aPitchedMark';
import { findMessages as messages } from './findMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface EditorialHelperProps {
  accountId: number;
  song: ReleaseOption | null;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

/** An editorial playlist has no email (design outreach c2 note): the Spotify for Artists route instead. */
const EditorialHelperComponent: React.FC<EditorialHelperProps> = ({ accountId, song, isOpen, onOpen, onClose }) => {
  const intl = useIntl();
  return (
    <div className="d-flex flex-column gap-2" data-testid="editorial-helper">
      <b>{intl.formatMessage(messages.editorialTitle)}</b>
      <p className={styles.small}>{intl.formatMessage(messages.editorialBody)}</p>
      <div>
        <SMLButton outline omitCap onClick={onOpen}>
          {intl.formatMessage(messages.writeS4a)}
        </SMLButton>
      </div>
      {song !== null && !isReleased(song.releaseDate) && (
        <S4aPitchedMark accountId={accountId} catalogItemUuid={song.catalogItemUuid} />
      )}
      {isOpen && <S4aHelperModal accountId={accountId} song={song} onClose={onClose} />}
    </div>
  );
};

export const EditorialHelper = TypedMemo(EditorialHelperComponent);
